/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S41_Item_1Inputs */

const es_privacy_policy_usage_s41_item_1 = /** @type {(inputs: Privacy_Policy_Usage_S41_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticacion y autorizacion: verificar su identidad y gestionar el acceso`)
};

const en_privacy_policy_usage_s41_item_1 = /** @type {(inputs: Privacy_Policy_Usage_S41_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication and authorization: verify identity and manage access`)
};

/**
* | output |
* | --- |
* | "Authentication and authorization: verify identity and manage access" |
*
* @param {Privacy_Policy_Usage_S41_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s41_item_1 = /** @type {((inputs?: Privacy_Policy_Usage_S41_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S41_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s41_item_1(inputs)
	return en_privacy_policy_usage_s41_item_1(inputs)
});
export { privacy_policy_usage_s41_item_1 as "privacy_policy.usage.s41_item_1" }